import {h, Fragment, toChildArray, isValidElement} from "preact";
import Else from "./else";
const If = ({children, condition}) => {
  return <Fragment>
    {toChildArray(children).filter(child => (condition) !== (child.type === Else))}
  </Fragment>
}

export default If;
